import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Badge } from 'react-bootstrap';
import {
  FaWhatsapp,
  FaEnvelope,
  FaExternalLinkAlt,
  FaIdCard,
  FaSignature,
  FaKey,
  FaCamera,
} from 'react-icons/fa';

function aplicarMascaraCelular(valor) {
  if (!valor) return '';
  var numeros = valor.replace(/\D/g, '');
  if (numeros.length <= 2) return '(' + numeros;
  if (numeros.length <= 6)
    return '(' + numeros.substring(0, 2) + ') ' + numeros.substring(2);
  if (numeros.length <= 10)
    return (
      '(' +
      numeros.substring(0, 2) +
      ') ' +
      numeros.substring(2, 6) +
      '-' +
      numeros.substring(6)
    );
  return (
    '(' +
    numeros.substring(0, 2) +
    ') ' +
    numeros.substring(2, 7) +
    '-' +
    numeros.substring(7, 11)
  );
}

function obterCelularLimpo(signatario) {
  if (!signatario.celular) return '';
  return signatario.celular.replace(/\D/g, '').trim();
}

const AUTH_EMAIL = 'email';
const AUTH_DOCUMENTO = 'official_document';
const AUTH_MANUSCRITO = 'handwritten';
const AUTH_SELFIE = 'selfie';

const ModalCanalNotificacao = function(props) {
  var show = props.show;
  var signatarios = props.signatarios || [];
  var onConfirm = props.onConfirm;
  var onCancel = props.onCancel;
  var documentoDigital = props.documentoDigital;

  const [whatsappAtivo, setWhatsappAtivo] = useState({});
  const [tipoAuth, setTipoAuth] = useState({});

  useEffect(
    function() {
      if (!show) return;
      const inicialWp = {};
      const inicialAuth = {};
      for (let i = 0; i < signatarios.length; i++) {
        const s = signatarios[i];
        const celular = obterCelularLimpo(s);
        inicialWp[i] = celular.length >= 10;
        if (!s.is_comprador) {
          const preferencia = s.tipo_autenticacao;
          if (
            preferencia === AUTH_DOCUMENTO ||
            preferencia === AUTH_MANUSCRITO ||
            preferencia === AUTH_SELFIE ||
            preferencia === AUTH_EMAIL
          ) {
            inicialAuth[i] = preferencia;
          } else {
            inicialAuth[i] = AUTH_EMAIL;
          }
        }
      }
      setWhatsappAtivo(inicialWp);
      setTipoAuth(inicialAuth);
    },
    [show]
  );

  const signatariosAtivos = [];
  for (let i = 0; i < signatarios.length; i++) {
    const s = signatarios[i];
    if (s.signatario && s.ativo !== false) {
      signatariosAtivos.push({ signatario: s, indice: i });
    }
  }

  function obterLinkProspecto(signatario) {
    if (!signatario.is_comprador || !documentoDigital) return null;
    var preVenda = documentoDigital.pre_venda;
    if (!preVenda || !preVenda.cliente) return null;
    var codigoProspecto = preVenda.cliente.codigo_prospecto;
    if (!codigoProspecto) return null;
    var familia = preVenda.empreendimento
      ? preVenda.empreendimento.codigo
      : null;
    var pv = documentoDigital.numero_pre_venda;
    return (
      '/prospectos/' +
      codigoProspecto +
      '/dados-cliente/pessoais?Familia=' +
      familia +
      '&PV=' +
      pv
    );
  }

  function toggleWhatsapp(indice) {
    setWhatsappAtivo(function(prev) {
      const novo = {};
      for (var key in prev) {
        novo[key] = prev[key];
      }
      novo[indice] = !prev[indice];
      return novo;
    });
  }

  function setarTipoAuth(indice, valor) {
    setTipoAuth(function(prev) {
      const novo = {};
      for (var key in prev) {
        novo[key] = prev[key];
      }
      novo[indice] = valor;
      return novo;
    });
  }

  function handleConfirm() {
    const signatariosAtualizados = signatarios.map(function(s, i) {
      const usaWhatsapp = whatsappAtivo[i] || false;
      const canal = usaWhatsapp ? 'whatsapp' : 'email';
      var auth = null;
      if (!s.is_comprador) {
        const escolhido = tipoAuth[i] || AUTH_EMAIL;
        if (
          escolhido === AUTH_DOCUMENTO ||
          escolhido === AUTH_MANUSCRITO ||
          escolhido === AUTH_SELFIE
        ) {
          auth = escolhido;
        }
      }
      return Object.assign({}, s, {
        canal_notificacao: canal,
        tipo_autenticacao: auth,
      });
    });
    onConfirm(signatariosAtualizados);
  }

  function renderToggleCanal(indice, temCelular, wpAtivo) {
    return (
      <div
        className="d-flex align-items-center"
        role="button"
        tabIndex={0}
        title={
          temCelular
            ? 'Canal de notificação: clique para alternar entre Email e WhatsApp'
            : 'Sem celular cadastrado — só Email'
        }
        style={{
          cursor: temCelular ? 'pointer' : 'not-allowed',
          opacity: temCelular ? 1 : 0.5,
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
        onClick={function() {
          if (temCelular) toggleWhatsapp(indice);
        }}
      >
        <div
          className="custom-control custom-switch mr-1"
          style={{ pointerEvents: 'none' }}
        >
          <input
            type="checkbox"
            className="custom-control-input"
            checked={wpAtivo}
            readOnly
          />
          <label className="custom-control-label"> </label>
        </div>
        {wpAtivo ? (
          <FaWhatsapp className="text-success mr-1" size={14} />
        ) : (
          <FaEnvelope className="text-muted mr-1" size={14} />
        )}
        <small>{wpAtivo ? 'WhatsApp' : 'Email'}</small>
      </div>
    );
  }

  function renderSelectAuth(indice, authAtual) {
    var icone = <FaKey className="text-muted mr-1" size={13} />;
    if (authAtual === AUTH_DOCUMENTO)
      icone = <FaIdCard className="text-primary mr-1" size={13} />;
    else if (authAtual === AUTH_MANUSCRITO)
      icone = <FaSignature className="text-primary mr-1" size={13} />;
    else if (authAtual === AUTH_SELFIE)
      icone = <FaCamera className="text-primary mr-1" size={13} />;

    return (
      <div className="d-flex align-items-center" title="Tipo de autenticação">
        {icone}
        <Form.Control
          as="select"
          size="sm"
          value={authAtual}
          onChange={function(e) {
            setarTipoAuth(indice, e.target.value);
          }}
          style={{ width: 190 }}
        >
          <option value={AUTH_EMAIL}>Token por Email</option>
          <option value={AUTH_DOCUMENTO}>Documento Oficial</option>
          <option value={AUTH_MANUSCRITO}>Assinatura Manuscrita</option>
          <option value={AUTH_SELFIE}>Selfie</option>
        </Form.Control>
      </div>
    );
  }

  function renderLinha(item) {
    const signatario = item.signatario;
    const indice = item.indice;
    const celular = obterCelularLimpo(signatario);
    const temCelular = celular.length >= 10;
    const wpAtivo = whatsappAtivo[indice] || false;
    const linkProspecto = obterLinkProspecto(signatario);
    const ehInterno = !signatario.is_comprador;
    const authAtual = ehInterno ? tipoAuth[indice] || AUTH_EMAIL : AUTH_EMAIL;
    const semTokenNaClickSign =
      authAtual === AUTH_DOCUMENTO ||
      authAtual === AUTH_MANUSCRITO ||
      authAtual === AUTH_SELFIE;

    return (
      <div key={indice} className="py-2 px-3 mb-2 border rounded">
        <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between">
          <div
            className="mb-2 mb-sm-0 mr-sm-3"
            style={{ minWidth: 0, flex: 1 }}
          >
            <div className="d-flex align-items-center flex-wrap">
              {linkProspecto ? (
                <a
                  href={linkProspecto}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-truncate font-weight-bold"
                >
                  {signatario.nome}
                  <FaExternalLinkAlt className="ml-1" size={11} />
                </a>
              ) : (
                <strong className="text-truncate">{signatario.nome}</strong>
              )}
              <Badge variant="info" className="ml-2">
                {signatario.descricao_tipo}
              </Badge>
            </div>
            <div className="text-muted small text-truncate">
              <FaEnvelope className="mr-1" />
              {signatario.email}
            </div>
          </div>
          <div
            className="d-flex align-items-center flex-wrap flex-shrink-0"
            style={{ gap: 12 }}
          >
            {renderToggleCanal(indice, temCelular, wpAtivo)}
            {ehInterno && renderSelectAuth(indice, authAtual)}
          </div>
        </div>
        {(wpAtivo && temCelular) || !temCelular || semTokenNaClickSign ? (
          <div
            className="mt-1 d-flex flex-wrap align-items-center"
            style={{ gap: 12 }}
          >
            {wpAtivo && temCelular && (
              <small className="text-muted d-flex align-items-center">
                <FaWhatsapp className="text-success mr-1" size={13} />
                {aplicarMascaraCelular(celular)}
              </small>
            )}
            {!temCelular && (
              <small className="text-warning">Sem celular cadastrado</small>
            )}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <Modal
      show={show}
      onHide={onCancel}
      size="lg"
      scrollable
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Notificação e Autenticação dos Signatários</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Escolha o <strong>canal de notificação</strong> (Email ou WhatsApp).
          Para signatários internos, escolha também a{' '}
          <strong>autenticação</strong>: token por email, documento oficial,
          assinatura manuscrita ou selfie. Compradores assinam sempre com token
          por email.
        </p>
        {signatariosAtivos.map(function(item) {
          return renderLinha(item);
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="success" onClick={handleConfirm}>
          Confirmar e Prosseguir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCanalNotificacao;
